import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import { get } from 'lodash';
import { pluralize } from 'utils/string_utils';
import * as actions from 'actions/assign';
import { Icon } from 'ui';
import ContentItem from 'components/shared/ContentItem';
import ScrollableContainer from 'components/shared/scrollable';
import * as selectors from 'selectors/assign';
import BlankSlate from './Blankslate';
import { TYPES, TYPE_ICONS } from '../../../constants/config';

class AssignableCollection extends PureComponent {
  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
    this.renderAssigneeItem = this.renderAssigneeItem.bind(this);
    this.renderAssignableItem = this.renderAssignableItem.bind(this);
  }

  get pagination() {
    const { data, pagination } = this.props;
    const { perPage, totalResults, ...rest } = pagination;
    return {
      hasMore: data.length < totalResults,
      moreCount: Math.min(perPage, totalResults - data.length),
      ...rest,
    };
  }

  renderBaseContentItem(item, props) {
    return (
      <ContentItem
        layout="list"
        active={item.selected}
        key={`${item.type}.${item.id}`}
        onClick={() => this.handleItemClick(item)}
        title={item.title}
        isJourney={this.props.contentType === 1}
        {...props}
      />
    );
  }

  renderPath(path) {
    const isCert = get(path, 'meta.isCertification');

    return this.renderBaseContentItem(path, {
      iconName: isCert
        ? TYPE_ICONS.Certification
        : TYPE_ICONS['LearningPaths::Path'],
      showCount: true,
    });
  }

  renderAssignableItem(content) {
    switch (content.type) {
      case TYPES.PATH:
        return this.renderPath(content);
      default:
        return this.renderBaseContentItem(content);
    }
  }

  renderAssigneeItem(item) {
    const { usersCount: count, isSmartGroup } = item.meta;
    const name =
      item.name && item.name.trim().length > 0 ? item.name : 'Unnamed User';
    return this.renderBaseContentItem(item, {
      title: name,
      count: count && count,
      countLabel: pluralize(count, 'User'),
      iconName: item.type.toLowerCase() === 'group' && 'group',
      invalid: item.meta.invalidGroup,
      showCount: item.type === 'Group',
      infoTooltip: isSmartGroup && this.props.smartGroupsTooltip,
      invalidTooltip: isSmartGroup && this.props.invalidTooltip,
    });
  }

  renderItems() {
    const { data, journeyData, type } = this.props;

    switch (type) {
      case 'CONTENT':
        return this.props.contentType === 0
          ? data.map(this.renderAssignableItem)
          : journeyData.map(this.renderAssignableItem);
      case 'ASSIGNEES':
        return data.map(this.renderAssigneeItem);
      default:
        return [];
    }
  }

  handleItemClick(item) {
    this.props.toggleItem(item);
  }

  render() {
    const { data, journeyData, loading, journeyLoading, requestNextPage } =
      this.props;
    const { hasMore, moreCount } = this.pagination;
    const containerStyle = { opacity: loading ? 0.5 : null };

    const isJourneyList = this.props.contentType === 1;

    const loadingState = isJourneyList
      ? isEmpty(journeyData) && journeyLoading
      : isEmpty(data) && loading;
    const blankState =
      this.props.selectedOptions.length === 0 ||
      (isJourneyList
        ? isEmpty(journeyData) && !journeyLoading
        : isEmpty(data) && !loading);

    return (
      <div
        className="AssignModal-dataView PathContentPicker-dataView PathContentPicker-dataView--list"
        style={containerStyle}
      >
        {loadingState && <p>{t('contents.assign_modal.loading_results')}</p>}
        {blankState && <BlankSlate />}
        {!blankState && !isEmpty(isJourneyList ? journeyData : data) && (
          <ScrollableContainer maxHeight={null}>
            {this.renderItems()}
            {!isJourneyList && hasMore && (
              <button
                type="button"
                className="AssignModal-showMoreButton"
                onClick={requestNextPage}
              >
                <Icon name="add" />
                Show {moreCount} More
              </button>
            )}
          </ScrollableContainer>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  type: state.activeStep,
  loading: state.loading,
  journeyLoading: state.journeyLoading,
  data: selectors.getAssignableData(state),
  pagination: state.pagination,
  smartGroupsTooltip: state.meta.i18n.smart_groups_calculation_tooltip,
  invalidTooltip: state.meta.i18n.invalid_group_tooltip,
  contentType: state.contentType,
  journeyData: selectors.getAssignableJourneyData(state),
  searchInput: state.params.query,
  selectedOptions: state.params.filter.type,
});

const mapDispatchToProps = {
  toggleItem: actions.toggleAssignableItem,
  requestNextPage: actions.requestNextPage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignableCollection);
